/** Logo shape with optional url (e.g. Company.logo from API). */
export type CompanyLogo = { url?: string | null } | null;

/**
 * Returns a valid company logo URL, or null if missing/placeholder.
 * Prefixes relative URLs with NEXT_PUBLIC_BASE_URL; filters out nopic placeholders.
 */
export function getValidCompanyUrl(logo?: CompanyLogo): string | null {
  if (!logo?.url) {
    return null;
  }

  const companyImageUrl = logo.url.startsWith("http")
    ? logo.url
    : `${process.env.NEXT_PUBLIC_BASE_URL ?? ""}${logo.url}`;

  const isPlaceholderImage =
    companyImageUrl.endsWith("nopic.jpg") ||
    companyImageUrl.endsWith("nopic.png");

  return isPlaceholderImage ? null : companyImageUrl;
}
